const images = {
  logos: {
    otp: {
      original: require("./logos/originals/otp-bank-logo.svg"),
      mini: require("./logos/mini/OTP.png"),
      thumbnail: require("./logos/originals/otp-bank-logo.svg"),
    },
    magnet: {
      original: require("./logos/originals/magnet-bank-logo.png"),
      mini: require("./logos/mini/Magnet.png"),
      thumbnail: require("./logos/originals/magnet-bank-logo.png"),
    },
    binx: {
      original: require("./logos/originals/binx.png"),
      mini: require("./logos/mini/binx.png"),
      thumbnail: require("./logos/originals/binx.png"),
    },
    cib: {
      original: require("./logos/originals/cib-bank-logo.svg"),
      mini: require("./logos/mini/CIB.png"),
      thumbnail: require("./logos/originals/cib-bank-logo.svg"),
    },
    citibank: {
      original: require("./logos/originals/citibank.svg"),
      mini: require("./logos/originals/citibank.svg"),
      thumbnail: require("./logos/originals/citibank.svg"),
    },
    dunabank: {
      original: require("./logos/originals/dunabank.png"),
      mini: require("./logos/originals/dunabank.png"),
      thumbnail: require("./logos/originals/dunabank.png"),
    },
    cibvallalati: {
      original: require("./logos/originals/cib-bank-logo.svg"),
      mini: require("./logos/mini/CIB.png"),
      thumbnail: require("./logos/originals/cib-bank-logo.svg"),
    },
    unicredit: {
      original: require("./logos/originals/unicredit-bank-logo.svg"),
      mini: require("./logos/mini/Unicredit.png"),
      thumbnail: require("./logos/originals/unicredit-bank-logo.svg"),
    },
    revolut: {
      original: require("./logos/originals/revolut-logo.svg"),
      mini: require("./logos/mini/Revolut.png"),
      thumbnail: require("./logos/originals/revolut-logo.svg"),
    },
    raiffeisen: {
      original: require("./logos/originals/raiffeisen-bank-logo.svg"),
      mini: require("./logos/mini/Raiffeisen.png"),
      thumbnail: require("./logos/originals/raiffeisen-bank-logo.svg"),
    },
    kh: {
      original: require("./logos/originals/kh-logo.png"),
      mini: require("./logos/mini/KH.png"),
      thumbnail: require("./logos/originals/kh-logo.png"),
    },
    budapest: {
      original: require("./logos/originals/budapest-bank-logo.svg"),
      mini: require("./logos/mini/BB.png"),
      thumbnail: require("./logos/originals/budapest-bank-logo.svg"),
    },
    erste: {
      original: require("./logos/originals/erste-bank-logo.svg"),
      mini: require("./logos/mini/Erste.png"),
      thumbnail: require("./logos/thumbnails/erstebank.svg"),
    },
    erstecorporate: {
      original: require("./logos/originals/erste-bank-logo.svg"),
      mini: require("./logos/mini/Erste.png"),
      thumbnail: require("./logos/thumbnails/erstebank.svg"),
    },
    granit: {
      original: require("./logos/originals/granit-logo.jpg"),
      mini: require("./logos/mini/Granit.png"),
      thumbnail: require("./logos/originals/granitbank-simple.svg"),
    },
    wise: {
      original: require("./logos/originals/wise-logo.png"),
      mini: require("./logos/originals/wise-logo.png"),
      thumbnail: require("./logos/originals/wise-logo.png"),
    },
    takarek: {
      original: require("./logos/originals/takarekbank-zrt-logo.svg"),
      mini: require("./logos/mini/Takarek.png"),
      thumbnail: require("./logos/originals/takarekbank-zrt-logo.svg"),
    },
    mkb: {
      original: require("./logos/originals/mkb-bank-logo.jpg"),
      mini: require("./logos/mini/MKB.jpg"),
      thumbnail: require("./logos/originals/mkb-bank-logo.jpg"),
    },
    barion: {
      original: require("./logos/originals/barion.png"),
      mini: require("./logos/mini/barion_min.jpeg"),
      thumbnail: require("./logos/originals/barion.png"),
    },
    ofsz: {
      original: require("./logos/originals/ofsz.svg"),
      mini: require("./logos/mini/ofsz.png"),
      thumbnail: require("./logos/originals/ofsz.svg"),
    },
    nobank: {
      original: require("./logos/originals/nobankicon.svg"),
      thumbnail: require("./logos/originals/nobankicon.svg"),
    },
    "ffe873d5-ad2f-4380-814e-70437324433a": {
      original: require("./logos/originals/multihaz-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    //Sample
    "429c30f3-e5d9-4c1c-a44f-53555d313abd": {
      original: require("./logos/originals/erste-bank-logo.svg"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "0f41f27e-e18f-4dc1-991a-de8c38bb9e06": {
      original: require("./logos/originals/billzone-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "f8756a3f-badf-4bc2-9681-5a8ab5215195": {
      original: require("./logos/originals/finistic-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "b812cfd0-c0d8-4cdb-8ddd-b73e4ebff563": {
      original: require("./logos/originals/netaccounting.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "86cb974c-8579-4d9a-999a-f7b5cf0bb2ef": {
      original: require("./logos/originals/dyc.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "0c470a51-b6f2-4683-8c54-5cc1ca08b881": {
      original: require("./logos/originals/logo_szlogan_egymas_alatt_szines.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "0906e55f-9fab-44e9-a8f7-80fbf05420be": {
      original: require("./logos/originals/konto-online-logo-2.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "ffb054af-185d-425c-a838-832d633f59e0": {
      original: require("./logos/originals/kh-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "2e357456-506c-429e-92e7-92551f27f2f1": {
      original: require("./logos/originals/cashbook-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "d23f5c73-3ef5-4b67-b8b1-3d3ce2aac779": {
      original: require("./logos/originals/szamlaparos.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "3c61ffa3-bc76-4488-9042-bda0a815ed8d": {
      original: require("./logos/originals/tecton.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "22a9adea-b4bd-4d6b-943e-57f569d54b99": {
      original: require("./logos/originals/sybell_RGB_pack_sybell_logo_RGB_szines.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "60a9fe9f-118b-4c73-96ed-61bf3a433dcc": {
      original: require("./logos/originals/IMA-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "2eb0990a-b66d-4d0c-9c9b-459c40abf99b": {
      original: require("./logos/originals/viharflotta_logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "0b4be870-7bfb-4183-bb01-7a2ddfc20e63": {
      original: require("./logos/originals/cegmenedzser-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "2f1b1122-7212-432e-9d4c-84299fb1472f": {
      original: require("./logos/originals/szamado-logo.svg"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "16c0a7da-556f-4f02-9cea-847152f3ba05": {
      original: require("./logos/originals/SmartERP_logo_final.svg"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "902b0421-e94a-4d35-b52b-322509378c49": {
      original: require("./logos/originals/cheppers.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "e62891fa-7320-4d60-b5b4-fa09ca6cad2d": {
      original: require("./logos/originals/pro-time-logo.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "f47eb175-2ef1-489f-8dae-962f9a6f1032": {
      original: require("./logos/originals/RSM.svg"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "df49703c-1335-41ff-8961-85bb5b9760af": {
      original: require("./logos/originals/keszletem.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "d8625301-8dfb-43b5-8e2f-f4da6c2f18c8": {
      original: require("./logos/originals/accent-hotels.svg"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "8614be04-17f7-4b89-8f7b-5efe41e942dc": {
      original: require("./logos/originals/DOTech.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "aa34790e-cd0f-47b9-afd1-46f7a260ed12": {
      original: require("./logos/originals/pickback.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
     "fc3407e2-1bf2-44cf-a3fe-d34a00016d58": {
      original: require("./logos/originals/swicon-black.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "d23f5c73-3ef5-4b67-b8b1-3d3ce2aac779": {
      original: require("./logos/originals/számlapáros.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "32416077-30e0-44a2-9eaf-d50457331087": {
      original: require("./logos/originals/penzum.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "98912d99-aaa5-4e86-a110-88695f9f3d11": {
      original: require("./logos/originals/magral.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "fb73b944-adc6-4c28-bf42-2bf5725518e1": {
      original: require("./logos/originals/cobra-test.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    "208ef674-3e03-4ba0-b183-5ff3bff39f1": {
      original: require("./logos/originals/makroteam.png"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
    noservice: {
      original: require("./logos/originals/noservice.svg"),
      thumbnail: require("./logos/originals/noservice.svg"),
    },
  },
  icons: {
    facebook: require("./icons/facebook.svg"),
    google: require("./icons/google.svg"),
  },

  underConstruction: {
    small: require("./under-construction/mobil-under-construction.png"),
    big: require("./under-construction/desktop-under-construction.png")
  },
};

export default images;
